import { forwardRef, ReactNode } from 'react'
import styled from 'styled-components'

import Text from '@/components/atomic/atoms/Text'
import Divider from '@/components/cell/atoms/Divider'

interface ContainerProps {
  $padding: number
  $onlyMobileLayout: boolean
}
const Container = styled.section<ContainerProps>`
  position: relative;

  ${({ $onlyMobileLayout, $padding }) =>
    $onlyMobileLayout &&
    `
    padding: ${$padding}px;
  `}

  padding: ${(props: ContainerProps) => props.$padding}px;
`

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`

export interface Props extends React.HTMLAttributes<HTMLElement> {
  children: ReactNode
  padding?: number
  hasDivider?: boolean
  dividerType?: 'list' | 'section'
  title?: string
  className?: string
  titleButtons?: ReactNode
  topComponent?: ReactNode
  bottomComponent?: ReactNode
  onlyMobileLayout?: boolean
}

const Section = forwardRef<HTMLElement, Props>(function Section(
  {
    children,
    padding = 26,
    hasDivider = true,
    dividerType = 'list',
    title = '',
    className,
    titleButtons,
    topComponent,
    bottomComponent,
    onlyMobileLayout = false,
  },
  ref,
) {
  return (
    <>
      <Container className={className} ref={ref} $padding={padding} $onlyMobileLayout={onlyMobileLayout}>
        {title !== '' && (
          <TitleWrapper>
            <Text element="h2" type="title3">
              {title}
            </Text>
            {titleButtons}
          </TitleWrapper>
        )}
        {title === '' && topComponent}
        {topComponent}
        {children}
        {bottomComponent}
      </Container>
      {hasDivider && <Divider type={dividerType} />}
    </>
  )
})

export default Section
